import { render, staticRenderFns } from "./PopUpSendHelpModel.vue?vue&type=template&id=3e213cb9"
import script from "./PopUpSendHelpModel.vue?vue&type=script&lang=js"
export * from "./PopUpSendHelpModel.vue?vue&type=script&lang=js"
import style0 from "./PopUpSendHelpModel.vue?vue&type=style&index=0&id=3e213cb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports